import type { Language } from "../typings";
import { paths } from "./paths";

export const companyName = "AgwiPol";

export const pageTitles: Record<
  Language,
  Record<keyof typeof paths, string>
> = {
  Russian: {
    home: "Главная",
    services: "Услуги",
    faq: "База знаний",
    contact: "Контакты",
  },
  Polish: {
    home: "Strona główna",
    services: "Usługi",
    faq: "Baza wiedzy",
    contact: "Kontakt",
  },
};

export const descriptions = {
  Russian:
    "Комплексная помощь иностранцам в Польше. Карта побыту, гражданство Польши, PESEL, Profil Zaufany, транскрипция документов, административное сопровождение.",
  Polish:
    "Kompleksowa pomoc dla cudzoziemców w Poslce. Karta pobytu, Obywatelstwo Polskie, PESEL, Profil Zaufany, transkrypcja dokumentów.",
};

export const tabTitles: Record<string, Record<Language, string>> = {
  [paths.home]: {
    Russian: `${companyName} | ${pageTitles.Russian.home}`,
    Polish: `${companyName} | ${pageTitles.Polish.home}`,
  },
  [paths.services]: {
    Russian: `${companyName} | ${pageTitles.Russian.services}`,
    Polish: `${companyName} | ${pageTitles.Polish.services}`,
  },
  [paths.faq]: {
    Russian: `${companyName} | ${pageTitles.Russian.faq}`,
    Polish: `${companyName} | ${pageTitles.Polish.faq}`,
  },
  [paths.contact]: {
    Russian: `${companyName} | ${pageTitles.Russian.contact}`,
    Polish: `${companyName} | ${pageTitles.Polish.contact}`,
  },
};

export const tabDescription: Record<Language, string> = {
  Russian: descriptions.Russian,
  Polish: descriptions.Polish,
};
